module.exports = __webpack_public_path__ + "media/octagon.09f97603.mp4";